module.exports = __webpack_public_path__ + "img/selected7-min.dfd7d6f8.png";